import styled, { css } from "styled-components";
import { devices } from "@/constants/media";

export const StyledSettingsContent = styled.div`
  display: flex;
  min-height: 322px;
  @media ${devices.sm} {
    flex-direction: column;
  }
`;

export const StyledSettingsContentLeft = styled.div`
  padding: var(--spacing-md);
  min-width: 240px;
  border-right: 1px solid var(--color-text-20);
  display: flex;
  flex-direction: column;
  gap: var(--spacing-xs);
  @media ${devices.sm} {
    border: none;
    flex-direction: row;
  }
`;

export const StyledSettingsContentRight = styled.div`
  flex: 1;
  padding: var(--spacing-md);
`;

export const StyledSettingsTabItem = styled.button<{
  $active?: boolean;
}>`
  display: flex;
  align-items: center;
  gap: var(--spacing-sm);
  padding: var(--spacing-sm) var(--spacing-md);
  color: var(--color-text);
  font-size: var(--font-size-md);
  transition: background-color var(--transition-fast);
  border-radius: var(--radius-md);
  &:hover {
    background-color: var(--color-text-10);
  }
  ${({ $active }) => $active ? 'background-color: var(--color-text-10);' : ''}
  @media ${devices.sm} {
    background-color: transparent;
    border-bottom: 2px solid;
    border-radius: 0;
    ${({ $active }) => $active ? css`
      border-color: var(--color-primary);
    ` : css`
      border-color: transparent;
    `}
  }
`;
